<template>
  <div class="num">
    <div class="list">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div class="list-item__value">{{ item.value }}</div>
        <div class="list-item__title">{{ item.title }}
          <div v-if="item.tip">
            <el-tooltip class="item" effect="dark" placement="top">
              <i class="el-icon-question"></i>
              <div slot="content">
                <p>{{ item.tip }}</p>
              </div>
            </el-tooltip>
          </div>
        </div>
        <img class="list-item__img" :src="item.img" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    totalAllData: { // 统计数据
      type: Object,
      default: () => { }
    }
  },
  computed: {
    ...mapGetters(["isDyAppOwner"]),
    list() {
      let hasValue = this.totalAllData && Object.keys(this.totalAllData).length
      let list = [{
        title: '销售订单数(含退款)',
        show: true,
        value: hasValue ? this.totalAllData.saleOrderNum : 0,
        img: require("@/assets/img/tk/order_1.png")
      },
      {
        title: '销售订单金额(含退款)(元)',
        show: true,
        value: hasValue ? this.totalAllData.saleOrderAmountStr : 0,
        img: require("@/assets/img/tk/order_2.png")
      }, {
        title: '退款订单数',
        show: true,
        value: hasValue ? this.totalAllData.refundOrderNum : 0,
        img: require("@/assets/img/tk/order_3.png")
      }, {
        title: '退款订单金额',
        show: true,
        value: hasValue ? this.totalAllData.refundFeeStr : 0,
        img: require("@/assets/img/tk/order_4.png")
      },
      {
        title: '实际成交订单',
        show: true,
        value: hasValue ? this.totalAllData.dealOrderNum : 0,
        tip: '销售订单数 - 退款订单数',
        img: require("@/assets/img/tk/order_5.png")
      }, {
        title: '实际成交金额',
        show: true,
        value: hasValue ? this.totalAllData.dealOrderAmountStr : 0,
        tip: '销售订单金额 - 退款订单金额',
        img: require("@/assets/img/tk/order_6.png")
      },
      {
        title: '我的预估佣金',
        show: !this.isDyAppOwner, // 非小程序主显示
        value: hasValue ? this.totalAllData.dyProxyCommissionStr : 0,
        tip: '未扣除达人佣金',
        img: require("@/assets/img/tk/order_7.png")
      },
      {
        title: '我的预估佣金',
        show: this.isDyAppOwner, // 小程序主显示
        value: hasValue ? this.totalAllData.appCommissionStr : 0,
        tip: '未扣除达人佣金',
        img: require("@/assets/img/tk/order_7.png")
      },
      {
        title: '代理预估佣金',
        show: this.isDyAppOwner, // 小程序主显示
        value: hasValue ? this.totalAllData.dyProxyCommissionStr : 0,
        img: require("@/assets/img/tk/order_6.png")
      },
      {
        title: '达人预估佣金',
        show: true,
        value: hasValue ? this.totalAllData.dyDarenCommissionStr : 0,
        img: require("@/assets/img/tk/order_8.png")
      },
      ]
      list = list.filter(item => item.show)
      console.log(list, 'list')
      return list
    }
  }
}
</script>
<style lang="less" scoped>
.num {
  background: #fff;
  margin-top: 24px;
  padding: 10px;

}

.list {
  display: flex;
  flex-wrap: wrap;

  &-item {
    background: #FFF8EC;
    padding: 16px;
    width: 173px;
    border-radius: 2px;
    position: relative;
    margin: 8px;

    &__value {
      font-size: 24px;
      font-weight: bold;
      z-index: 1;
    }

    &__title {
      display: flex;
      color: #666666;
      font-size: 12px;
      z-index: 1;
    }

    &__img {
      width: 40px;
      height: 40px;
      object-fit: fill;
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 0;
    }
  }

  // &-item:nth-child(6n) {
  //   margin-right: 0;
  // }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/groupOrderList/NumList.vue